import { render } from "./AfterSend.vue?vue&type=template&id=5aea6a6e"
import script from "./AfterSend.vue?vue&type=script&lang=js"
export * from "./AfterSend.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__